<template>
  <div class="header">
    <div class="nav">
        <div class="nav_logo"><a href="http://www.hefeigc.com"><img src="../assets/newlogo.png" alt="nav_logo"></a></div>
        <div class="nav_right">
          <el-menu :default-active="activeIndex" class="menu" mode="horizontal" @select="handleSelect" active-text-color="#e10062">
            <el-menu-item index="1"><router-link to="/">首页</router-link></el-menu-item>
            <el-menu-item index="2">
              <router-link to="/about?m=2">
                关于高创
              </router-link>
            </el-menu-item>
            <el-submenu index="3">
              <template slot="title">政策法规</template>
              <el-menu-item index="3-1"><router-link to="/policyList?m=3-1&list=1-1">安徽省政策</router-link></el-menu-item>
              <el-menu-item index="3-2"><router-link to="/policyList?m=3-2&list=1-2">合肥市政策</router-link></el-menu-item>
              <el-menu-item index="3-3"><router-link to="/policyList?m=3-3&list=1-3">高新区政策</router-link></el-menu-item>
              <el-menu-item index="3-4"><router-link to="/policyList?m=3-4&list=2-1">政策申报</router-link></el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">新闻动态</template>
              <el-menu-item index="4-1"><router-link to="/newsList?m=4-1&list=1">园区动态</router-link></el-menu-item>
              <el-menu-item index="4-2"><router-link to="/newsList?m=4-2&list=2">企业新闻</router-link></el-menu-item>
              <el-menu-item index="4-3"><router-link to="/newsList?m=4-3&list=3">最新公告</router-link></el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">智慧高创</template>
              <el-menu-item index="5-1">
                <router-link to="/medium?m=5-1&list=1">载体+</router-link>
              </el-menu-item>
              <el-menu-item index="5-2">
                <router-link to="/growIntro?m=5-2&list=3">成长+</router-link>
              </el-menu-item>
              <el-menu-item index="5-3">
                <router-link to="/plat?m=5-3&list=1">平台+</router-link>
              </el-menu-item>
              <el-menu-item index="5-4">
                <router-link to="/finan?m=5-4&list=1">金服+</router-link>
              </el-menu-item>
              <el-menu-item index="5-5">
                <router-link to="/wisdowPlus?m=5-5&list=1">智慧+</router-link>
              </el-menu-item> 
            </el-submenu>
            <el-menu-item index="6">
              <router-link to="/park?m=6">
                园区企业
              </router-link>
            </el-menu-item>
            <el-menu-item index="7">
              <router-link to="/partyIndex" target="_blank">
                特色党建</router-link>
              </el-menu-item>
          </el-menu>
          <span class="btn_apply">
            <a href="http://zhgc.hefeigc.com" target="_blank">申请入园</a>
          </span>
        </div>
    </div>
  </div>
</template>

<script>
import common from '../../static/js/common.js'
export default {
  name: 'Header',
  data () {
    return {
      active:1,
      activeIndex: '1'  
    }
  },
  methods:{
    handleSelect(key, keyPath) {  //选择栏目
      this.activeIndex=key;
    }
  },
  created (){
    var list = common.getUrlParam('list'); 
    var m = common.getUrlParam('m')||'1';
    this.activeIndex=m;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {width:100%;height:70px;background: #fff;}
  .header .nav{width:1200px;margin:0 auto;overflow: hidden;}
  .header .nav .nav_logo{float:left;width:267.4px;height:66.7px;}
  .header .nav .nav_logo img{width:90%;margin-top:5px;}
  .nav_right{float:right;}
  .menu li i{display:none;}
  .nav_right ul,.nav_right ul li{float:left;list-style-type: none;font-weight: 600;color:#333;}
  .nav_right ul li a{text-decoration:none;font-size:14px;width:80px;text-align:center;display: inline-block;color:#333;}
  .nav_right .el-menu--horizontal>.el-menu-item.is-active{border-bottom:4px solid #F51F1F;}
  .nav_right .el-menu--horizontal{border-bottom:none;}
  .nav_right .el-menu--horizontal>.el-menu-item{height:70px;line-height:70px;}
  .btn_apply a{background:#E60012;width:88px!important;height:36px;line-height:36px;color:#fff!important;border-radius: 20px;text-align: center;margin-top:17px;display:inline-block;font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/components/VueHeader.vue